export default __webpack_public_path__ + "static/media/logo.287b757c.svg";